/**
 * OVERRIDE AlbumView.jsx
 */

import AlbumView from '../../../../components/View/AlbumView';

export default AlbumView;